import { defineComponent as _defineComponent } from 'vue'
import VulnerabilitySeverity from '@/_core/entities/vulnerability/ui/VulnerabilitySeverity/VulnerabilitySeverity.vue';
import SeverityCountBadge from '@/_core/entities/vulnerability/ui/SeverityCountBadge/SeverityCountBadge.vue';
import SeverityDistribution from '@/_core/entities/report/ui/SeverityDistribution/SeverityDistribution.vue';
import type { TComplianceRequirement, TComplianceRequirementItem } from '@/_core/entities/report/models/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComplianceSummaryRow',
  props: {
    requirement: null,
    expanded: { type: Boolean },
    selectedRequirementId: null,
    selectedItemId: null
  },
  emits: ["toggle", "viewRequirement", "viewItem"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'toggle'): void;
  (e: 'viewRequirement'): void;
  (e: 'viewItem', item: TComplianceRequirementItem): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  requirement: TComplianceRequirement;
  expanded: boolean;
  selectedRequirementId?: string;
  selectedItemId?: string;
};





const ROW_GRID =
  'tw:grid-cols-[1.5rem_minmax(10rem,1fr)_4rem_minmax(10rem,22rem)_6rem] ' +
  'tw:max-[890px]:grid-cols-[1.5rem_minmax(0,1fr)_7rem_9rem] ' +
  'tw:max-[576px]:grid-cols-[1.5rem_minmax(0,1fr)_auto_auto]';

const ITEM_ROW_GRID =
  'tw:grid-cols-[1.5rem_minmax(10rem,1fr)_4rem_minmax(10rem,22rem)_6rem] ' +
  'tw:max-[890px]:grid-cols-[minmax(0,1fr)_7rem_9rem] ' +
  'tw:max-[576px]:grid-cols-[minmax(0,1fr)_auto_auto]';

const TREE_LINE =
  'tw:relative tw:max-[890px]:before:hidden tw:max-[890px]:after:hidden ' +
  "tw:before:content-[''] tw:before:absolute tw:before:left-[34px] tw:before:top-0 tw:before:bottom-0 tw:before:w-px tw:before:bg-[#e4e8ee] " +
  "tw:after:content-[''] tw:after:absolute tw:after:left-[34px] tw:after:top-1/2 tw:after:w-4 tw:after:h-px tw:after:bg-[#e4e8ee]";

const TREE_LINE_LAST =
  'tw:before:!bottom-1/2 tw:before:!w-4 tw:before:!bg-transparent tw:before:border-l tw:before:border-b tw:before:border-[#e4e8ee] tw:before:rounded-bl-[10px] tw:after:hidden';

return { __sfc: true,props, emit, ROW_GRID, ITEM_ROW_GRID, TREE_LINE, TREE_LINE_LAST, VulnerabilitySeverity, SeverityCountBadge, SeverityDistribution }
}

})